"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomYearWidget = void 0;
var React = require("react");
var moment = require("moment");
var FalconQuestionWidgetBase_1 = require("./FalconQuestionWidgetBase");
var journey_model_1 = require("@athena-portal/journey-model");
var InfoQuestionWrapper_1 = require("../components/infoQuestion/InfoQuestionWrapper");
var services_1 = require("@falcon/services");
var CustomYearWidget = exports.CustomYearWidget = /** @class */ (function (_super) {
    __extends(CustomYearWidget, _super);
    function CustomYearWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.componentDidMount = function () {
            var interactionYearString = _this.bindFromField(_this.interactionField);
            if (interactionYearString) {
                var interactionDate = moment(interactionYearString, moment.ISO_8601);
                if (interactionDate.isValid()) {
                    _this.setState({
                        year: Number(interactionDate.format("YYYY"))
                    });
                }
                else {
                    _this.setState({
                        year: ""
                    }, function () { return _this.updateInteractionField(); });
                }
            }
        };
        _this.componentDidUpdate = function (prevProps, prevState) {
            var newYearString = _this.state.year;
            if (prevState.year !== newYearString) {
                if (!newYearString) {
                    _this.setState({
                        year: ""
                    });
                }
                else {
                    _this.setState({
                        year: Number(_this.state.year)
                    });
                    _this.updateInteractionField();
                }
            }
        };
        _this.updateInteractionField = function () {
            _this.props.onStateChange(_this.interactionField, _this.state.year);
            _this.changelogRecorder.recordQuestion("change", _this.props);
        };
        _this.renderInputField = function () {
            return (React.createElement("div", { className: "input-group" },
                React.createElement("div", { id: _this.props.question.name, className: "customDate-container" },
                    React.createElement("input", { id: "".concat(_this.props.question.name, "-year"), className: "form-control ".concat(_this.getInputValidationClass(), " customDate-year"), "aria-label": "Year input field", type: "text", maxLength: 4, pattern: "[0-9]*", readOnly: _this.isReadOnly(), value: _this.state.year, disabled: _this.getSetting(services_1.INPUT_DISABLED_SETTING, false), onClick: _this.executeNativeEvent, onFocus: _this.executeNativeEvent, onChange: _this.handleYearChange, onBlur: _this.handleOnBlurEvent }))));
        };
        _this.handleYearChange = function (event) {
            var date = (event.target.validity.valid) ? event.target.value : _this.state.year;
            event.persist();
            _this.setState({
                year: date
            });
        };
        _this.handleOnBlurEvent = function (event) {
            _this.validateInternal(_this.state.year);
            _this.executeNativeEvent(event);
        };
        _this.interactionField = _this.props.question.interactionField;
        _this.state = {
            year: ""
        };
        return _this;
    }
    CustomYearWidget.prototype.render = function () {
        var label = this.props.question.label ? this.props.question.label : this.renderHtml(this.getSetting("labelHtml"));
        var info = this.renderHtml(this.getSetting("infoHtml") || "");
        if (info) {
            return (React.createElement(InfoQuestionWrapper_1.InfoQuestionWrapper, { label: label, infoType: this.getSetting("infoType"), info: info, infoTitle: this.getSetting("infoTitle"), hideInfoButton: this.isMtaAndDisabled() },
                this.renderInputField(),
                this.renderValidationResult()));
        }
        else {
            return this.renderInputField();
        }
    };
    CustomYearWidget = __decorate([
        (0, journey_model_1.settings)([
            { name: "labelHtml", type: journey_model_1.TypeDescriptions.String },
            { name: "infoType", type: journey_model_1.TypeDescriptions.String },
            { name: "infoTitle", type: journey_model_1.TypeDescriptions.String },
            { name: "infoHtml", type: journey_model_1.TypeDescriptions.String },
            { name: services_1.INPUT_DISABLED_SETTING, type: journey_model_1.TypeDescriptions.Boolean },
        ]),
        __metadata("design:paramtypes", [Object])
    ], CustomYearWidget);
    return CustomYearWidget;
}(FalconQuestionWidgetBase_1.FalconQuestionWidgetBase));
//# sourceMappingURL=CustomYearWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/CustomYearWidget.js
// module id = 3680
// module chunks = 0